import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// third-party
import { Provider as ReduxProvider } from 'react-redux';
import { ConfigProvider } from 'contexts/ConfigContext';
import telegramAnalytics from '@telegram-apps/analytics';

// scroll bar
import 'simplebar/dist/simplebar.min.css';

// tailwind css
import './index.css';

// project import
import App from './App';
import { store } from 'store';
import reportWebVitals from './reportWebVitals';

try {
  const analyticsToken = import.meta.env.VITE_TELEGRAM_ANALYTICS_TOKEN;
  if (analyticsToken) {
    telegramAnalytics.init({ token: analyticsToken, appName: 'anon_app' });
  }
} catch (err) {
  console.error('Telegram Analytics init failed', err);
}

const container = document.getElementById('root');
const root = createRoot(container);

// const root = ReactDOM.createRoot(document.getElementById('root'));

// ==============================|| MAIN - REACT DOM RENDER  ||============================== //

root.render(
  <ReduxProvider store={store}>
    <ConfigProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
      </BrowserRouter>
    </ConfigProvider>
  </ReduxProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
